import { render, staticRenderFns } from "./BaselineComparisonTab.vue?vue&type=template&id=def895ca"
import script from "./BaselineComparisonTab.vue?vue&type=script&lang=js"
export * from "./BaselineComparisonTab.vue?vue&type=script&lang=js"
import style0 from "./BaselineComparisonTab.vue?vue&type=style&index=0&id=def895ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports